import { useEffect, useState } from 'react'
import {
  GET_PROJECT_CATEGORY_RECOMMENDATION_ENABLED,
  POST_RECOMMEND_PROJECT_CATEGORY,
  ProjectCategoryRecommendationItem,
  ProjectCategoryRecommendationMaterial,
} from '@/api/reportApi'
import { isResponseCodeSuccess } from '@/tools/util'

/** SCP 最多展示的推荐条数，服务端可能返回更多。 */
const MAX_VISIBLE = 5

export const RECOMMEND_LOADING_TEXT = '系统正在推荐类目，可同时搜索选择类目'
export const RECOMMEND_FAILED_TEXT = '系统推荐功能失效，请搜索该商品类目'

interface Params {
  platformCode: string
  /** 取当前已填写的物料信息，点击时才求值，保证拿到最新输入 */
  getMaterial: () => ProjectCategoryRecommendationMaterial
  onWarning: (text: string) => void
}

/**
 * 项目类目 AI 推荐。推荐结果由类目下拉框渲染，等待和失败也在下拉框里提示，
 * 全程不禁用人工搜索。
 */
export const useProjectCategoryRecommend = (params: Params) => {
  const { platformCode, getMaterial, onWarning } = params

  const [enabled, setEnabled] = useState(false)
  const [loading, setLoading] = useState(false)
  const [failed, setFailed] = useState(false)
  const [requestId, setRequestId] = useState('')
  const [items, setItems] = useState<ProjectCategoryRecommendationItem[]>([])
  /** 下拉框当前是否展示推荐结果，用户开始搜索或选中后让位给人工搜索 */
  const [showing, setShowing] = useState(false)
  /** 受控展开：点击智能推荐后立即把浮层撑开，等待文案和推荐结果都在浮层里 */
  const [open, setOpen] = useState(false)

  useEffect(() => {
    let cancelled = false
    setEnabled(false)
    reset()
    if (!platformCode) return
    GET_PROJECT_CATEGORY_RECOMMENDATION_ENABLED({ platformCode })
      .then((res) => {
        if (!cancelled && isResponseCodeSuccess(res.code)) {
          setEnabled(Boolean(res.data))
        }
      })
      .catch(() => undefined)
    return () => {
      cancelled = true
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [platformCode])

  function reset() {
    setLoading(false)
    setFailed(false)
    setItems([])
    setRequestId('')
    setShowing(false)
    setOpen(false)
  }

  /** 回到人工搜索状态：下拉框换回类目池结果，占位文案也不再停在推荐提示上 */
  const hideRecommendations = () => {
    setShowing(false)
    setFailed(false)
  }

  const recommend = async () => {
    const material = getMaterial()
    if (!material.productName?.trim()) {
      onWarning('请先填写物料信息')
      return
    }
    setLoading(true)
    setFailed(false)
    setItems([])
    setShowing(true)
    // 请求发出就把浮层撑开，等待文案显示在浮层里而不是等用户去点类目框
    setOpen(true)
    try {
      const res = await POST_RECOMMEND_PROJECT_CATEGORY({
        platformCode,
        material,
      })
      const data = isResponseCodeSuccess(res.code) ? res.data : undefined
      if (!data?.success) {
        setFailed(true)
        setRequestId('')
        return
      }
      const visible = (data.recommendations || []).slice(0, MAX_VISIBLE)
      setRequestId(data.requestId || '')
      setItems(visible)
      setFailed(visible.length === 0)
    } catch {
      setFailed(true)
      setRequestId('')
    } finally {
      setLoading(false)
    }
  }

  return {
    enabled,
    loading,
    failed,
    items,
    requestId,
    /** 下拉框是否用推荐结果替代人工搜索结果 */
    showingRecommendations: showing && (loading || failed || items.length > 0),
    /** 受控展开状态，交给类目下拉框 */
    open,
    setOpen,
    recommend,
    hideRecommendations,
  }
}
import { useEffect, useState } from 'react'
import {
  GET_PROJECT_CATEGORY_RECOMMENDATION_ENABLED,
  POST_RECOMMEND_PROJECT_CATEGORY,
  ProjectCategoryRecommendationItem,
  ProjectCategoryRecommendationMaterial,
} from '@/api/reportApi'
import { isResponseCodeSuccess } from '@/tools/util'

/** SCP 最多展示的推荐条数，服务端可能返回更多。 */
const MAX_VISIBLE = 5

export const RECOMMEND_LOADING_TEXT = '系统正在推荐类目，可同时搜索选择类目'
export const RECOMMEND_FAILED_TEXT = '系统推荐功能失效，请搜索该商品类目'

interface Params {
  platformCode: string
  /** 取当前已填写的物料信息，点击时才求值，保证拿到最新输入 */
  getMaterial: () => ProjectCategoryRecommendationMaterial
  onWarning: (text: string) => void
}

/**
 * 项目类目 AI 推荐。推荐结果由类目下拉框渲染，等待和失败也在下拉框里提示，
 * 全程不禁用人工搜索。
 */
export const useProjectCategoryRecommend = (params: Params) => {
  const { platformCode, getMaterial, onWarning } = params

  const [enabled, setEnabled] = useState(false)
  const [loading, setLoading] = useState(false)
  const [failed, setFailed] = useState(false)
  const [requestId, setRequestId] = useState('')
  const [items, setItems] = useState<ProjectCategoryRecommendationItem[]>([])
  /** 下拉框当前是否展示推荐结果，用户开始搜索或选中后让位给人工搜索 */
  const [showing, setShowing] = useState(false)
  /** 受控展开：点击智能推荐后立即把浮层撑开，等待文案和推荐结果都在浮层里 */
  const [open, setOpen] = useState(false)

  useEffect(() => {
    let cancelled = false
    setEnabled(false)
    reset()
    if (!platformCode) return
    GET_PROJECT_CATEGORY_RECOMMENDATION_ENABLED({ platformCode })
      .then((res) => {
        if (!cancelled && isResponseCodeSuccess(res.code)) {
          setEnabled(Boolean(res.data))
        }
      })
      .catch(() => undefined)
    return () => {
      cancelled = true
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [platformCode])

  function reset() {
    setLoading(false)
    setFailed(false)
    setItems([])
    setRequestId('')
    setShowing(false)
    setOpen(false)
  }

  /** 回到人工搜索状态：下拉框换回类目池结果，占位文案也不再停在推荐提示上 */
  const hideRecommendations = () => {
    setShowing(false)
    setFailed(false)
  }

  const recommend = async () => {
    const material = getMaterial()
    if (!material.productName?.trim()) {
      onWarning('请先填写物料信息')
      return
    }
    setLoading(true)
    setFailed(false)
    setItems([])
    setShowing(true)
    // 请求发出就把浮层撑开，等待文案显示在浮层里而不是等用户去点类目框
    setOpen(true)
    try {
      const res = await POST_RECOMMEND_PROJECT_CATEGORY({
        platformCode,
        material,
      })
      const data = isResponseCodeSuccess(res.code) ? res.data : undefined
      if (!data?.success) {
        setFailed(true)
        setRequestId('')
        return
      }
      const visible = (data.recommendations || []).slice(0, MAX_VISIBLE)
      setRequestId(data.requestId || '')
      setItems(visible)
      setFailed(visible.length === 0)
    } catch {
      setFailed(true)
      setRequestId('')
    } finally {
      setLoading(false)
    }
  }

  return {
    enabled,
    loading,
    failed,
    items,
    requestId,
    /** 下拉框是否用推荐结果替代人工搜索结果 */
    showingRecommendations: showing && (loading || failed || items.length > 0),
    /** 受控展开状态，交给类目下拉框 */
    open,
    setOpen,
    recommend,
    hideRecommendations,
  }
}
